import { IGetLead, IGetLeadRequest, IObject, LeadPayload } from './lead.interface';
import { getUTMParams, isBulkUpgrade, isUserTypeIsKAM } from './lead.util';
import { enablePlatformLogin, findParamFromUrl, getFromSessionStorage, getQueryString, isSingleUpgradeOrShiftingJourney } from 'common/utils/app.utils';
import { COMMON_API_HEADERS, LEAD_API_HEADERS_DEV, MODULE_ID } from './constant';
import { PRODUCT_NAME, PRODUCT_TYPE, USER_TYPE, USER_TYPE_KAM } from 'common/constants/app.constants';
import AppConfiguration, { ENV_NAME } from '../config/config';

const DEFAULT_PRODUCT = PRODUCT_TYPE.DEDICATED_INTERNET;
export const isDevEnv = () => AppConfiguration.env === ENV_NAME.DEV;

export const getPartyId = () => {
  const partyId = findParamFromUrl('partyId');
  if (isDevEnv() && !partyId) {
    return isBulkUpgrade() ? '25227908' : '25222859';
  }
  return partyId ?? null;
};

export const getLoginToken = () => {
  if(enablePlatformLogin()){
    return localStorage?.getItem('rbacToken') ?? '';
  } else{
    return localStorage?.getItem('accessToken') ?? '';
  }
  
};

export const getParams = (params: IObject) => {
  const serviceType = getFromSessionStorage(MODULE_ID, PRODUCT_NAME) || DEFAULT_PRODUCT;
  return { serviceType, ...params };
};

export const getLeadHeaders = (headers: IObject) => {
  if (isDevEnv()) {
    return { ...LEAD_API_HEADERS_DEV, ...headers };
  }
  return { ...COMMON_API_HEADERS, ...headers };
};

export const getLeadPayload = (extraPayload?: IObject) => {
  const payload: LeadPayload = {
    partyId: getPartyId(),
    sendToCbft: true,
    utm: getUTMParams()
  } as LeadPayload;

  if (isBulkUpgrade()) {
    payload.orderType = 'CHANGE_ORDER';
    payload.orderSubType = 'UPGRADE';
    payload.journeyType = 'MULTI_SITE';
  }
  return { ...payload, ...extraPayload };
};

export const getRequest = (extrahHeaders?: IObject, extraPayload?: IObject, extraParams?: IObject) => {
  const payload = getLeadPayload(extraPayload);
  const headers = getLeadHeaders(extrahHeaders ?? {});
  const params = getParams(extraParams ?? {});
  return { headers, payload, params };
};

const getPayloadForExistingLead = (rawRequest: IGetLeadRequest = {} as IGetLeadRequest) => {
  const queryParams = getQueryString() as { leadId: string; cartId: string };
  const { leadId, cartId } = queryParams;

  const payload = {} as IGetLead;
  payload.partyId = getPartyId();
  payload.aehAccessToken = getLoginToken();
  payload.leadId = isUserTypeIsKAM() ? cartId?.trim() ?? leadId?.trim() : leadId?.trim() ?? null;
  payload.pnqToken = isUserTypeIsKAM();

  return { ...payload, ...rawRequest.payload };
};

export const getURLForFetchingExisitingLead = (isOrderSummaryPage: boolean) => {
  if (isUserTypeIsKAM() || isSingleUpgradeOrShiftingJourney()) {
    return `${AppConfiguration.pnqapiBaseUrl}login/aeh`;
  }
  return isOrderSummaryPage ? `${AppConfiguration.dedicatedSummaryAuthApiUrl}login/aeh` : `${AppConfiguration.apiBaseUrl}login/aeh`;
};

export const getRequestForExistingLead = (rawRequest?: IGetLeadRequest) => {
  let request = {} as IGetLeadRequest;
  request.payload = getPayloadForExistingLead(rawRequest);
  return { ...rawRequest, ...request };
};
